import * as React from "react";

export class RibbonButton extends React.Component<{
    text: string
    handler: Function | any
    modifier?: string
}, {}> {
    render() {
        const cls: string = "rj-ribbon__button" + (this.props.modifier ? ` rj-ribbon__button--${this.props.modifier}` : "");
        return (
            <button className={cls} onClick={this.props.handler} >{this.props.text}</button>
        )
    }
}